import { createContext } from 'react';
import { SHOW_ALL } from '../i18n/keyConstants';



const selectedFilters = { status: '', role: '' };
export const initialState = {
    filters: [],
    selectedFilters: selectedFilters,
    defaultFilters: [],
    selectedCourseStatus: [{ label: SHOW_ALL, value: null }],
    selectedCourseRole: [{ label: SHOW_ALL, value: null }],
    isResettingFilters: false,
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'FILTERS':
            return {
                ...state,
                filters: action.payload,
                defaultFilters: action.payload,
            };
        case 'RESET_FILTERS':
            return {
                ...state,
                filters: [],
                defaultFilters: [],
                selectedCourseStatus: [{ label: SHOW_ALL, value: null }],
                selectedCourseRole: [{ label: SHOW_ALL, value: null }],
                isResettingFilters: null, //fungerar inte med false
            };
        case 'FILTERS_RESET':
            return {
                ...state,
                isResettingFilters: false,
            };
        case 'SELECTED_FILTERS':
            return {
                ...state,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.payload }),
            };
        case 'FILTERS_AND_SELECTED_FILTERS':
            return {
                ...state,
                filters: action.payload,
                defaultFilters: action.payload,
                currentPage: 1,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.columnNameVal }),
            };
        case 'SELECTED_COURSE_STATUS':
            return {
                ...state,
                selectedCourseStatus: action.payload,
            };
        case 'SELECTED_COURSE_ROLE':
            return {
                ...state,
                selectedCourseRole: action.payload,
            };
        case 'SELECTED_FILTERS_AND_FILTERS_RESET':
            return {
                ...state,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.payload }),
                isResettingFilters: false,
            };
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);
